export const company = {
 name: 'AutomateHQ',
 description: 'AutomateHQ is an AI and workflow automation business serving companies in Singapore and Thailand.',
 email: 'hello.automatehq@gmail.com',
 authorName: 'Automate HQ',
 authorRole: '',
};
export const dateLabel = (date: string, locale = 'en-GB') => new Date(`${date}T00:00:00Z`).toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
